import React, { useState } from 'react';
import { Col } from 'react-grid-system';
import styled from 'styled-components';
import ReturnFormInput from '../ReturnFormInput';
import { ReturnFormsResponse } from '../../../hooks/useReturnForms';
import { theme } from '../../../utils/theme';
import Typography from '../../atoms/Typography';

const StyleErrorMsg = styled(Typography)`
  padding-top: 8px;
  padding-left: 8px;
`;

export type ReturnFormInputAnswer = { value: unknown; type: string; };

type ReturnFormComponentsProps = {
  components: ReturnFormsResponse['components'];
  onSubmit: (answers: Record<string, ReturnFormInputAnswer>) => void;
  savedAnswers: Record<string, ReturnFormInputAnswer>;
  errors?: Record<number, { value: string }>;
};

const ReturnFormComponents = ({
  components,
  onSubmit,
  savedAnswers,
  errors = {},
}: ReturnFormComponentsProps) => {
  const [returnFormsAnswers, setReturnFormsAnswers] = useState<Record<string, ReturnFormInputAnswer>>(savedAnswers);

  const onComponentChange = (answers: Record<string, ReturnFormInputAnswer>) => {
    setReturnFormsAnswers(answers);

    onSubmit(answers);
  };

  const sortedComponents = [...components].sort(
    (a, b) => a.sortOrder - b.sortOrder,
  );

  return (
    <>
      {sortedComponents.map((returnComponent) => {
        const { id, labelTranslationKey, componentConfiguration, ...componentProps } = returnComponent;

        const onChange = (value: unknown) => {
          const newAnswers = {
            ...returnFormsAnswers,
            [id]: {
              value,
              type: componentConfiguration.type,
            },
          };

          onComponentChange(newAnswers);
        };

        return (
          <Col xs={12} key={id} style={{ marginBottom: '16px' }}>
            <ReturnFormInput
              label={labelTranslationKey}
              onChange={onChange}
              value={returnFormsAnswers[id]?.value as any}
              {...componentConfiguration}
              {...componentProps}
            />
            {errors[id] && (
              <StyleErrorMsg color={theme.colors.red[80]} variant="input-error">
                {errors[id]?.value}
              </StyleErrorMsg>
            )}
          </Col>
        );
      })}
    </>
  );
};

export default ReturnFormComponents;
